import { render, staticRenderFns } from "./BcSnackbar.vue?vue&type=template&id=3d657316"
import script from "./BcSnackbar.vue?vue&type=script&lang=js"
export * from "./BcSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports